export default function VSpacer() {
  return (
    <hr className="w-0.5 min-h-[80px] block my-8 md:my-12 mx-auto sm:h-[16vh] bg-ltcream" />
  );
}
